import React from "react";
import { cn } from "../../utils/themeClasses.js";
import {
  blockSectionToolbarFiltersRowClassName,
  blockSectionToolbarMobileNormalizeClassName,
} from "../../design/tokens.js";

/**
 * Einheitliche Toolbar in Collapsible-Blöcken (Dateien, Stunden, …):
 * - Mobile: Zeile 1 = Suche + Hauptaktion, Zeile 2 = Filter
 * - Desktop (md+): eine Zeile; Hauptaktion rechts (order-last)
 */
export default function BlockSectionToolbar({
  search,
  action = null,
  filters = null,
  className = "",
}) {
  return (
    <div
      className={cn(
        "mt-1.5 mb-1.5 flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center md:gap-2",
        blockSectionToolbarMobileNormalizeClassName,
        className,
      )}
    >
      <div
        className={cn(
          "flex flex-nowrap items-stretch gap-2 min-w-0 max-md:w-full md:contents",
          blockSectionToolbarMobileNormalizeClassName,
        )}
      >
        {search}
        {action ? (
          <div className="shrink-0 flex flex-nowrap items-stretch gap-1.5 md:order-last [&_.wrtk-btn]:whitespace-nowrap">
            {action}
          </div>
        ) : null}
      </div>
      {filters ? (
        <div
          className={cn(
            blockSectionToolbarFiltersRowClassName,
            blockSectionToolbarMobileNormalizeClassName,
          )}
        >
          {filters}
        </div>
      ) : null}
    </div>
  );
}
